// @flow strict
import React from 'react';
import cx from 'classnames';
// eslint-disable-next-line css-modules/no-unused-class
import styles from '../../styles.scss';
import PageContentBlock from '../../../../internal/PageContentBlock';
import { Button } from '../../../../internal/Button';

export type PartnerType = 'Bronze' | 'Silver' | 'Gold';
export type PartnerBarPropsType = {|
  partnerType: PartnerType,
  serviceSpecialty: Array<string>,
  industryExperience: Array<string>,
  onClick: () => void,
  ctaText: string,
|};

const ExpertiseList = (props: { list: Array<string>, title: string, partnerType: string }) => (
  <div className={styles.listContainer}>
    <h2 className={cx([styles.title, styles[`is${props.partnerType}`]])}>{props.title}</h2>
    <ul>
      {props.list.map((item, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <li key={index} className={cx([styles.item, styles[`is${props.partnerType}`]])}>
          {item}
        </li>
      ))}
    </ul>
  </div>
);

const Badge = (props: { partnerType: PartnerType }) => (
  <div className={cx([styles.badge, styles[`is${props.partnerType}Background`]])}>
    <span className={styles.badgeName}>{props.partnerType}</span>
  </div>
);

export default (props: PartnerBarPropsType) => (
  <PageContentBlock background="Dark" removePadding>
    <div className={styles.wrapper}>
      <Badge partnerType={props.partnerType} />
      <ExpertiseList
        list={props.serviceSpecialty}
        title="Service Specialty"
        partnerType={props.partnerType}
      />
      <ExpertiseList
        list={props.industryExperience}
        title="Industry Experience"
        partnerType={props.partnerType}
      />

      <div className={styles.ctaButton}>
        <Button variant={props.partnerType} onClick={props.onClick}>
          {props.ctaText}
        </Button>
      </div>
    </div>
  </PageContentBlock>
);
